import { Form, Input } from "antd";
import { TypeEndereco } from "../../../../Models/Pessoa/Endereco";
import { Regex } from "../../../../Constants";
import InputMask from "react-input-mask";
import EstadoSelect from "./Estado/EstadoSelect";
import MunicipioSelect from "./Municipio/MunicipioSelect";
import { Formatacoes } from "../../../../Utils/Formatacao";
import { EnderecoService } from "../../../../Services/EnderecoService";
import { useMutation, useQuery } from "@tanstack/react-query";

interface IEnderecoFormBasicProps {
    id?: string;
    value?: TypeEndereco;
    onChange?: (endereco?: TypeEndereco) => void;
}

export function EnderecoFormBasic({
    id,
    value,
    onChange,
    ...rest
}: IEnderecoFormBasicProps) {
    const form = Form.useFormInstance();
    const enderecoForm = Form.useWatch([id], form);
    const codEstado = Form.useWatch([id, "estado", "codigo"], form);
    const enderecoServices = new EnderecoService();

    const {
        data : estados
    } = useQuery({
        queryKey: ["listarEstados"],
        queryFn: () => enderecoServices.listarEstados()
    });

    const {
        mutateAsync
    } = useMutation({
        mutationFn : async (cep:string) => {
            const enderecoViaCep = await enderecoServices.obterInformacoesDoCEP(cep!);

            if (enderecoViaCep == null || enderecoViaCep == undefined) return null;

            const endereco = await Formatacoes.viaCepParaEndereco(enderecoViaCep, estados?.data);

            return {
                ...enderecoForm,
                ...endereco
            } as TypeEndereco;
        },
        onSuccess: (data) => {
            if (data != null)
                onChange?.(data);
        }
    });

    return <>
        <Form.Item<any>
            name={[id, "cep"]}
            validateTrigger="onBlur"
            label='CEP'
            rules={[
                {
                    required: true,
                    pattern: Regex.CEP,
                    validator: async (rules, val: string) => {
                        if (val == undefined) return Promise.reject("O CEP é obrigatório!");

                        if (!val.match(rules.pattern!)) return Promise.reject("Insira um CEP no formato válido!");

                        const cep = Formatacoes.sanitizar("-_", val);

                        try {
                            await mutateAsync(cep!);
                        } catch (error) {
                            return Promise.reject(error);
                        }
                    }
                }
            ]}
        >
            <InputMask mask="99999-999">
                <Input placeholder="00000-000" />
            </InputMask>
        </Form.Item>
        <Form.Item<any>
            name={[id, "logradouro"]}
            rules={[{ required: true }]} label='Logradouro'
        >
            <Input
                placeholder="Informe o logradouro"
            />
        </Form.Item>
        <Form.Item<any>
            name={[id, "estado", "codigo"]}
            rules={[{ required: true }]}
            label='Estado'
        >
            <EstadoSelect />
        </Form.Item>
        <Form.Item<any>
            name={[id, "municipio", "codigo"]}
            rules={[{ required: true }]}
            label='Município'
        >
            <MunicipioSelect codEstado={codEstado} />
        </Form.Item>
        <Form.Item<any>
            name={[id, "bairro"]}
            rules={[{ required: true }]}
            label='Bairro'
        >
            <Input
                placeholder="Informe o bairro"
            />
        </Form.Item>
        <Form.Item<any>
            name={[id, "numero"]}
            label='Número'
            rules={[{ required: true }]}
        >
            <Input placeholder="Informe o número" />
        </Form.Item>
        <Form.Item<any>
            name="complemento"
            label='Complemento'
        >
            <Input placeholder="Informe o complemento" />
        </Form.Item>
    </>;
}